import { Button, CircularProgress } from '@material-ui/core'
import { ButtonProps } from '@material-ui/core/Button'
import { connect } from 'formik'
import React from 'react'

interface IProps extends ButtonProps {}

export const SubmitButton = connect<IProps>(
  ({ formik, children, ...props }) => (
    <Button
      variant="contained"
      onClick={() => formik.handleSubmit()}
      disabled={!formik.isValid || formik.isSubmitting}
      {...props}
    >
      {formik.isSubmitting ? <CircularProgress /> : children}
    </Button>
  ),
)
